import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollPosition = (commentRefs, findParentIds, expandThreads) => {
  const location = useLocation();
  
  const saveScrollPosition = useCallback(() => {
    return document.documentElement.scrollTop || document.body.scrollTop;
  }, []);

  const restoreScrollPosition = useCallback((position) => {
    window.requestAnimationFrame(() => {
      window.scrollTo(0, position);
    });
  }, []);

  const scrollToComment = useCallback((commentId, highlightBg) => {
    if (commentRefs.current[commentId]) {
      // First expand any collapsed threads if this is a reply
      const parentIds = findParentIds(commentId);
      if (parentIds.length > 0) {
        expandThreads(parentIds);
      }

      // Delay scrolling slightly to allow for thread expansion
      setTimeout(() => {
        commentRefs.current[commentId]?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        // Add a temporary highlight effect
        const el = commentRefs.current[commentId];
        if (el) {
          el.style.transition = 'background-color 0.3s ease';
          el.style.backgroundColor = highlightBg;
          setTimeout(() => {
            el.style.backgroundColor = '';
          }, 2000);
        }
      }, 100);
    }
  }, [commentRefs, findParentIds, expandThreads]);

  // Handle URL hash for comment navigation
  const handleHashScroll = useCallback((comments, highlightBg) => {
    const hash = location.hash;
    if (hash && hash.startsWith('#comment-')) {
      const commentId = hash.replace('#comment-', '');
      if (comments.length > 0) {
        scrollToComment(commentId, highlightBg);
      }
    }
  }, [location.hash, scrollToComment]);

  return {
    saveScrollPosition,
    restoreScrollPosition,
    scrollToComment,
    handleHashScroll
  };
};
